import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './styles';
import { USER_PROFILE_TYPES, VIEWABLE_FORM_MODES } from '../../constants';
import {
  selectIsGettingUserProfile,
  selectPersonalProfileFormMode,
  selectBusinessProfileFormMode,
  selectServiceAreaFormMode,
} from '../../store/selectors';
import BuilderProfilePersonalContainer from './BuilderProfilePersonalContainer';
import BuilderProfileBusinessContainer from './BuilderProfileBusinessContainer';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  isGettingUserProfile: PropTypes.bool.isRequired,
  personalProfileFormMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.VIEWING,
    VIEWABLE_FORM_MODES.EDITING,
  ]).isRequired,
  businessProfileFormMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.VIEWING,
    VIEWABLE_FORM_MODES.EDITING,
  ]).isRequired,
  serviceAreaFormMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.VIEWING,
    VIEWABLE_FORM_MODES.EDITING,
  ]).isRequired,
};

const BuilderProfileContainer = props => {
  const {
    classes,
    isGettingUserProfile,
    personalProfileFormMode,
    businessProfileFormMode,
    serviceAreaFormMode,
  } = props;

  const canEnableEditing = profileType => {
    switch (profileType) {
      case USER_PROFILE_TYPES.PERSONAL:
        return (
          businessProfileFormMode !== VIEWABLE_FORM_MODES.EDITING &&
          serviceAreaFormMode !== VIEWABLE_FORM_MODES.EDITING
        );
      case USER_PROFILE_TYPES.BUSINESS:
        return (
          personalProfileFormMode !== VIEWABLE_FORM_MODES.EDITING &&
          serviceAreaFormMode !== VIEWABLE_FORM_MODES.EDITING
        );
      case USER_PROFILE_TYPES.SERVICE_AREA:
        return (
          personalProfileFormMode !== VIEWABLE_FORM_MODES.EDITING &&
          businessProfileFormMode !== VIEWABLE_FORM_MODES.EDITING
        );
      default:
        // eslint-disable-next-line no-console
        return true;
    }
  };

  if (isGettingUserProfile) {
    return (
      <div className={classes.progressWrapper}>
        <CircularProgress className={classes.progress} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.innerWrapper}>
        <div className={classes.personalWrapper}>
          <BuilderProfilePersonalContainer
            enableEditing={canEnableEditing(USER_PROFILE_TYPES.PERSONAL)}
          />
        </div>
        <div className={classes.businessWrapper}>
          <BuilderProfileBusinessContainer
            enableEditing={canEnableEditing(USER_PROFILE_TYPES.BUSINESS)}
          />
        </div>
      </div>
    </div>
  );
};

BuilderProfileContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  isGettingUserProfile: selectIsGettingUserProfile(),
  personalProfileFormMode: selectPersonalProfileFormMode(),
  businessProfileFormMode: selectBusinessProfileFormMode(),
  serviceAreaFormMode: selectServiceAreaFormMode(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(BuilderProfileContainer),
);
